import { useTranslation } from 'react-i18next'
import { KIND } from 'baseui/button'
import SDButton from '@/shared/components/SDComponents/SDButton/SDButton'
import SDNotification from '@/shared/components/SDComponentsNewDesign/SDNotification/SDNotification'
import usePulseScope from '@/shared/components/PulseScope/usePulseScope'
import IconRefresh from '@/shared/icons/NewDesign/IconRefresh'
import HelpPanel from '../HelpPanel/HelpPanel'
import HelpScreenshot from '../HelpScreenshot/HelpScreenshot'
import RegistrationCode from '../RegistrationCode'
import VerifyDetailsHelp from '../VerifyDetailsHelp/VerifyDetailsHelp'
import { HELP_IMAGES } from '../helpImages'
import { JOURNEY_COPY } from '../fidelityJourney'
import type { AppConnectionProps } from '../types'
import {
  StyledButtonBlock,
  StyledHelpNote,
  StyledHint,
  StyledScreenshotGrid,
  StyledScript,
  StyledSeparator,
} from '../styled-components'

const AppConnection = ({
  hidden,
  introHidden,
  subjectHidden,
  dictationHidden,
  dictationScript,
  info,
  code,
  generateAction,
  regenerateAction,
}: AppConnectionProps) => {
  const { t } = useTranslation()
  const isPulse = usePulseScope()

  if (hidden) {
    return null
  }

  return (
    <>
      <div hidden={introHidden}>
        <HelpPanel hidden={subjectHidden} title={t(`${JOURNEY_COPY}.help.subject_title`)}>
          <StyledHelpNote dangerouslySetInnerHTML={{ __html: t(`${JOURNEY_COPY}.help.subject_body`) }} />
        </HelpPanel>
        <HelpPanel title={t(`${JOURNEY_COPY}.help.download_links_title`)}>
          <HelpScreenshot src={HELP_IMAGES.emailAppLinks} alt={t(`${JOURNEY_COPY}.help.download_links_alt`)} />
        </HelpPanel>
        <StyledScript $pulse={isPulse} dangerouslySetInnerHTML={{ __html: t(`${JOURNEY_COPY}.app.script`) }} />
        <HelpPanel title={t(`${JOURNEY_COPY}.help.app_title`)}>
          <StyledScreenshotGrid>
            <HelpScreenshot
              src={HELP_IMAGES.appSignUp}
              alt={t(`${JOURNEY_COPY}.help.app_sign_up_alt`)}
              caption={t(`${JOURNEY_COPY}.help.app_sign_up_caption`)}
            />
            <HelpScreenshot
              src={HELP_IMAGES.appCodeLink}
              alt={t(`${JOURNEY_COPY}.help.app_code_alt`)}
              caption={t(`${JOURNEY_COPY}.help.app_code_caption`)}
            />
          </StyledScreenshotGrid>
        </HelpPanel>
      </div>
      <StyledScript hidden={dictationHidden} $pulse={isPulse} dangerouslySetInnerHTML={{ __html: dictationScript }} />
      <RegistrationCode {...code} />
      <StyledButtonBlock hidden={generateAction.hidden}>
        {/* @ts-ignore */}
        <SDButton
          block={true}
          disabled={generateAction.disabled}
          isLoading={generateAction.loading}
          onClick={generateAction.onClick}
          startEnhancer={generateAction.refreshIcon ? <IconRefresh /> : undefined}
        >
          {generateAction.label}
        </SDButton>
      </StyledButtonBlock>
      <StyledButtonBlock hidden={regenerateAction.hidden}>
        {/* @ts-ignore */}
        <SDButton
          block={true}
          kind={KIND.secondary}
          disabled={regenerateAction.disabled}
          isLoading={regenerateAction.loading}
          onClick={regenerateAction.onClick}
          startEnhancer={<IconRefresh />}
        >
          {regenerateAction.label}
        </SDButton>
      </StyledButtonBlock>
      <StyledHint>{info}</StyledHint>
      <div hidden={dictationHidden}>
        <StyledSeparator />
        <VerifyDetailsHelp
          kicker={t(`${JOURNEY_COPY}.help.journey_kicker_app`)}
          src={HELP_IMAGES.appCheckDetails}
          alt={t(`${JOURNEY_COPY}.help.journey_app_alt`)}
        />
        <SDNotification type='positive' iconType='check' primaryText={t(`${JOURNEY_COPY}.dictation.done_note`)} />
      </div>
    </>
  )
}

export default AppConnection
